<template>
    <v-dialog-old ref="dialog" id="promotionEdit" @hidden="resetComponentData()" :onCloseEsc="onclose">
        <image-cropper
            ref="cropper"
            :img="M.img"
            type="promotions"
            width="500"
            height="281"
            :widthBox="500"
            :cropBoxDataLeft="0"
            :viewMode="currentUser.role === 'admin' ? 0 : 1"
            @crop-upload-success="cropUploadSuccess"
            upload-url="/imageCropperNew/promotions"
        />

        <ValidationObserver ref="promotionEditForm">
            <form >
              <div v-if="M.moderationNeeded" style="margin-right: 3px;" class="alert alert-warning">
                Внимание! Изменения отправлены на проверку.<br/>
                После проверки менеджером обновлённая информация появится на сайте.
              </div>
                <div v-if="!M.editEnable" style="margin-right: 3px;" class="alert alert-warning">
                    Внимание! Изменение акции недоступно.<br/>
                    Акция связана с другими клиниками, поэтому редактирование возможно только в кабинете сети.
                </div>
                <fieldset>
                    <legend>Общая информация</legend>

                    <table class="grid" valign="top">
                        <tr valign="top">
                            <td rowspan="5" width="265">
                                <drag-and-drop :disabled="!M.editEnable" @fileDropped="openCropWithNewFile">
                                    <div class="imageCropper">
                                        <button type="button" v-show="M.img !== ''"
                                                class="resetBtn small redHover" tooltip="Удалить"
                                                @click.prevent.stop="imageCropperDelete"
                                                :disabled="!M.editEnable"
                                        >

                                            <i class="fas fa-trash"></i>
                                        </button>
                                        <img src="" class="avatar"
                                             :src="M.img ? storagePublicUrl + '/images/promotions/265x149/' + M.img : ''"
                                             width="265" height="149" @click.prevent.stop="imageCropperOpen"
                                             style="cursor: pointer; background-position: center; background-repeat: no-repeat; background-size: cover;"
                                             :style="'background-image:url(/_assets/pic_promo.svg)'"
                                        />
                                        <button v-if="M.id"
                                                :disabled="!isActive"
                                                class="button small"
                                                @click.prevent.stop="openPromotionPage"
                                                width="265"
                                                v-tooltip="`https://doctu.ru/${city}/${M.networkClinics?.length ? 'net' : 'clinic'}/${url}/promo`"
                                                style="margin: 5px 0 !important; width: 100%"
                                        >
                                            <i class="fas fa-link"/> Показать на сайте
                                        </button>
                                    </div>
                                </drag-and-drop>
                            </td>
                            <td colspan="3" width="100%">
                                <label>Название</label>
                                <vee-textarea
                                    v-model="M.name"
                                    placeholder="Название"
                                    :rows="3"
                                    :v-beautify="'capitalize itemclean typograf'"
                                    rules="required"
                                    autofocus
                                ></vee-textarea>
                            </td>
                        </tr>
                        <tr valign="top">
                            <td width="33%">
                                <label>Публиковать с</label>
                                <date-piker
                                    rules="required"
                                    style="height: 25px"
                                    v-model="M.dateFrom"
                                    :disabled="!M.editEnable || (M.moderationNeeded && (currentUser.role === 'admin' || currentUser.isSupport))"
                                    :clearable="false"
                                    :disable-highlighting="true"
                                    :default-value="today"
                                    :disabled-date="(date) => date < startOfToday"
                                />
                            </td>
                            <td width="33%">
                                <label>Длительность</label>
                                <div>
                                    <ValidationProvider v-slot="{ errors }"
                                                        :rules="{required: true, min_value: 1}">

                                        <input type="number"
                                               v-model="M.duration"
                                               step="1"
                                               v-units.literal="`дн`"
                                               @input="calculateDateTill"
                                               :class="{hasError: errors[0]}"
                                               name="Длительность"
                                               :disabled="!M.editEnable || (M.moderationNeeded && (currentUser.role === 'admin' || currentUser.isSupport))"
                                               v-tooltip.bottom-end="{content: errors[0], template: $errTemplate}"
                                        />
                                    </ValidationProvider>
                                </div>
                            </td>
                            <td width="33%">
                                <label>Действует по</label>
                                <ValidationProvider :rules="{required: true}" v-slot="{errors}">
                                    <div style="height: 23px; margin-bottom: 5px;"
                                         :class="{'hasError': errors[0]}"
                                         v-tooltip.bottom-end="{content: errors[0], template: $errTemplate}"
                                    >

                                        <date-piker
                                            style="height: 25px"
                                            v-model="M.dateTill"
                                            :disabled="!M.editEnable || (M.moderationNeeded&& (currentUser.role === 'admin' || currentUser.isSupport))"
                                            :disabled-date="(date) => date < new Date(minDateTill)"
                                            @input="handleClearDateTill"
                                            @change="calculateDuration"
                                            :disable-highlighting="true"
                                        />

                                    </div>
                                </ValidationProvider>

                            </td>
                        </tr>
                        <tr height="50" valign="top">
                            <td width="33%" valign="top">
                                <label>Скидка (не обязательно)</label>
                                <ValidationProvider v-slot="{ errors }"
                                                    :rules="{numeric: true, max_value: 100}">

                                    <input
                                        v-mask="'###'"
                                        type="number"
                                        v-units.literal="`%`"
                                        v-model="M.discount"
                                        :disabled="!M.editEnable || (M.moderationNeeded && (currentUser.role === 'admin' || currentUser.isSupport))"

                                        :class="{'hasError' : errors[0]}"
                                        name="«Скидка»"
                                        v-tooltip="{
                                           content: errors[0],
                                           template: $errTemplate,
                                       }"
                                    />
                                </ValidationProvider>

                            </td>
                            <td width="33%"></td>
                            <td width="33%"></td>
                        </tr>
                    </table>
                </fieldset>
                <fieldset>
                    <legend>Описание</legend>
                    <ValidationProvider v-slot="{ errors }" rules="required">
                        <v-quill :disabled="!M.editEnable || (M.moderationNeeded&& (currentUser.role === 'admin' || currentUser.isSupport))"
                                 ref="quill"
                                 v-model="M.description"
                                 placeholder="Описание"
                                 :class="{hasError: errors[0], 'ql-container ql-snow': true}"
                                 v-tooltip="{content: errors[0], template: $errTemplate}"
                                 :config="quillConfig"/>
                    </ValidationProvider>
                </fieldset>
                <fieldset v-if="M.networkClinics && M.networkClinics.length">
                    <legend>Клиники</legend>
                    <table class="grid" :class="{attentionValidationOnSubmitError: showInvalidClinics}">
                        <tr v-for="row in M.networkClinics">
                            <td>
                                <label>
                                    <input type="checkbox" v-model="row.checked" @change="toggleNetworkClinics">
                                    <span>{{ row.name }}</span>
                                    <br>
                                    <small style="margin-left: 20px; font-size: 14px;">
                                        {{ row.address }}
                                    </small>
                                </label>
                            </td>
                        </tr>
                    </table>
                </fieldset>
            </form>
        </ValidationObserver>
        <footer v-if="$can('admin.moderation.promotions.update') || $can('network.promotions.*') || $can('clinics.promotions.*')">
            <v-loading-component :disabled="!M.editEnable || (M.moderationNeeded&& (currentUser.role === 'admin' || currentUser.isSupport))" @click="onUpdate">
                <template slot-scope="{ loadingClass }">
                    <button :disabled="!M.editEnable || (M.moderationNeeded&& (currentUser.role === 'admin' || currentUser.isSupport)) || !needSave"
                            :class="[{green: needSave}, loadingClass]">
                        Сохранить
                    </button>
                </template>
            </v-loading-component>
            <v-loading-component
                :disabled="!M.editEnable || (M.moderationNeeded&& (currentUser.role === 'admin' || currentUser.isSupport))"
                v-if="
                    actionType !== 'create' &&
                    ($can('admin.moderation.promotions.delete') || $can('network.promotions.*') || $can('clinics.promotions.*'))
                "
                @click="onDelete">

                <template slot-scope="{ loadingClass }">
                    <button :disabled="!M.editEnable || (M.moderationNeeded&& (currentUser.role === 'admin' || currentUser.isSupport))" :class="['redHover', loadingClass]"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAFwSURBVGhD7ZmtSgVRFIVHBDEIahMUX0AFg8EgWHwEQRCsPoAWq8Fg1SCCVYuCJvEHk8VkEGwWX8AsFl0L9oaDHPHOZZ87w2V98JXFMPssmDn3cqYSQggBpuEBvIH3Ge/gMZyFrWUSfsDvDvyE87CV7MHcov/yDLaSS+iLPIWbGQ+hX/MMe8oAHO/AW+iL3Lbst2vQr3m17D8HYQij0Ic34RwMQUWCDCvi78gu9JufWxZtbkbYO+LsQB/CXakEvZihInVotMgYXDGXGCR4TocZGAvQ8wkGRqNFuHjP3xkkeE75h9J5hJ6vMzBUpA4qYqpINCpiqkg0KmKqSDQqYqpINCpitr7IIuSZL31hkOA5nWJgXEPPVxkYjRaJREXq0DdFeDDtQx4YFOAE+gye3BdhGfoQegRznw66dR9+Qb//BiwCj06fYFqmlG8wPT4Kh1sot9jc8Cj5WzQDizME+ShcwNwHz269gltwBAohRF9SVT/YcCJDemJ9EwAAAABJRU5ErkJggg==" width="25" height="25">
                    </button>
                </template>
            </v-loading-component>
        </footer>
    </v-dialog-old>
</template>
<script>
import dragAndDrop from '@base/DragAndDrop.vue';
import imageCropper from '@base/ImageCropper.vue';
import {STORAGE_PUBLIC} from "@global/const";
import {mapState} from "vuex";


export default {
    components: {
        dragAndDrop,
        imageCropper,
    },
    mounted() {

    },
    props: {
        networkClinics: {
            type: Array,
            default() {
                return []
            }
        },
    },
    data(){
        return{
            actionType:'',
            durationPreset: '',
            netInvalidShowFlag: false,
            city: '',
            url: '',
            Mhashcode: null,
            MhashNew: null,
            M:{
                id: '',
                name: '',
                description: '',
                duration: '',
                dateFrom: this.today,
                dateTill: '',
                discount: null,
                img: '',
                networkClinics: [],
                editEnable: true
            },
        }
    },
    methods:{
        onUpdate(btn) {
            if(!this.needSave){
                return;
            }
            if(!this.M.editEnable || (this.M.moderationNeeded&& (this.currentUser.role === 'admin' || this.currentUser.isSupport))){
                return;
            }
            this.netInvalidShowFlag = true
            if(this.M.networkClinics && this.M.networkClinics.length && this.M.networkClinics.filter((item) => item.checked === true).length === 0) {
                return;
            }

            btn.startLoadingAnimation();

            this.$refs.promotionEditForm.validate().then(success => {
                if (!success) {
                    const el = document.querySelector(".hasError:first-of-type");
                    if (el) {
                        el.scrollIntoView({behavior: "smooth"});
                    }

                    btn.stopLoadingAnimation()
                    return;
                }

                if (this.$refs.quill.inProcess) {
                    this.$refs.quill.quillEditor.setSelection(null)
                    setTimeout(() => {
                        this.update().then(() => btn.stopLoadingAnimation(), () => btn.stopLoadingAnimation());
                    }, 450)
                } else {
                    this.update().then(() => btn.stopLoadingAnimation(), () => btn.stopLoadingAnimation());
                }

            });
        },
        update() {
            let preparedData = JSON.parse(JSON.stringify(this.M));

            preparedData.dateFrom = (this.M.dateFrom ? this.formatDate(this.M.dateFrom.trim()) : null);
            preparedData.dateTill = (this.M.dateTill ? this.formatDate(this.M.dateTill.trim()) : null);

            if (this.actionType === 'create'){
                return this.axios.post('promotions/create', preparedData).then(() => {
                    this.hideAndRefresh()
                }).catch((error) => {
                });
            }else{
                return this.axios.post('promotions/update/' + this.M.id, preparedData).then(() => {
                    this.hideAndRefresh()
                }).catch((error) => {
                });
            }
        },
        onDelete(btn) {
            if(!this.M.editEnable || (this.M.moderationNeeded && (this.currentUser.role === 'admin' || this.currentUser.isSupport))){
                return;
            }
            this.$modal('Вы уверены, что хотите удалить акцию?', {
                name: 'Удалить',
                btnClass: 'red',
                callback: () => {
                    btn.startLoadingAnimation();

                    this.$refs.promotionEditForm.validate().then(success => {
                        if (!success) {
                            const el = document.querySelector(".hasError:first-of-type");
                            el.scrollIntoView({behavior: "smooth"});
                            btn.stopLoadingAnimation()
                            return;
                        }

                        if (this.$refs.quill.inProcess) {
                            this.$refs.quill.quillEditor.setSelection(null)
                            setTimeout(() => {
                                this.delete().then(() => btn.stopLoadingAnimation(), () => btn.stopLoadingAnimation());
                            }, 450)
                        } else {
                            this.delete().then(() => btn.stopLoadingAnimation(), () => btn.stopLoadingAnimation());
                        }

                    });
                }
            }, {});
        },
        delete() {
            this.netInvalidShowFlag = true;
            if(this.M.networkClinics && this.M.networkClinics.length && this.M.networkClinics.filter((item) => item.checked === true).length === 0) {
                return;
            }
            if (this.currentUser.role === 'admin') {
                return this.axios.post('promotions/published/delete/' + this.M.id, this.M).then(() => {
                    this.hideAndRefresh()
                });
            }
            return this.axios.post('promotions/delete/' + this.M.id, this.M).then(() => {
                this.hideAndRefresh()
            }).catch((error) => {
            });
        },
        toggleNetworkClinics(){
            this.MhashNew = JSON.stringify(this.M).hashCode()
        },
        resetComponentData() {
            this.M = {
                    id: '',
                    name: '',
                    description: '',
                    duration: '',
                    dateFrom: this.$moment().format("DD.MM.YYYY"),
                    dateTill: '',
                    discount: null,
                    img: '',
                    networkClinics: [],
                    editEnable: true,
                }
            this.netInvalidShowFlag = false
            this.actionType = ''
            this.city = ''
            this.url = ''
            this.Mhashcode = null
            this.MhashNew = null
        },

        onclose() {
            this.resetComponentData()
            this.$refs.dialog.hide();
        },
        create(){
            this.resetComponentData();
            this.actionType = 'create';

            if(this.currentUser.role === 'network') {
                this.M.networkClinics = JSON.parse(JSON.stringify(this.networkClinics))
            }


            this.$refs.dialog.show();

        },
        read(data, city, url){
            this.resetComponentData()
            this.M = data
            this.city = city
            this.url = url;

            let dateFrom = this.$moment(this.M.dateFrom, "YYYY-MM-DD");
            let dateTill = this.M.dateTill ? this.$moment(this.M.dateTill, "YYYY-MM-DD") : null;
            let now = this.$moment();

            this.M.dateFrom = dateFrom.format('DD.MM.YYYY');
            if (dateTill) {
                this.M.dateTill = dateTill.format('DD.MM.YYYY');
            }

            if(this.currentUser.role === 'admin' && data.networkClinics?.length) {
                this.M.networkClinics = JSON.parse(JSON.stringify(data.networkClinics))
                data.clinics.forEach((clinic)=>{
                    this.M.networkClinics.map((c)=>{
                        if(c.account_id === clinic.account_id){
                            c.checked = true
                        }
                    })
                })
            }
            if(this.currentUser.role === 'network') {
                this.M.networkClinics = JSON.parse(JSON.stringify(this.networkClinics))
                data.clinics.forEach((clinic)=>{
                    this.M.networkClinics.map((c)=>{
                        if(c.account_id === clinic.account_id){
                            c.checked = true
                        }
                    })
                })
                this.M.editEnable = true
            }
            if(this.currentUser.role === 'admin') {
                this.M.editEnable = true
            }
            this.actionType = 'update';

            this.$refs.dialog.show();

            setTimeout(() => {
                this.Mhashcode = JSON.stringify(this.M).hashCode();
                this.MhashNew = JSON.stringify(this.M).hashCode();
            }, 500)

        },

        openCropWithNewFile(file) {
            if(!this.M.editEnable){
                return;
            }
            this.$refs.cropper.preloadFile(file);
            this.$refs.cropper.showModal();
        },
        imageCropperDelete: function (event) {
            this.$modal("Удалить логотип?", {
                    name: 'Удалить',
                    callback: () => {
                        this.M.img = '';
                    }
                },
                {
                    name: 'Нет'
                }
            );
        },
        imageCropperOpen() {
            if(!this.M.editEnable){
                return;
            }
            if (this.M.img === '') {
                this.$refs.cropper.showFileChooser();
            } else {
                this.$refs.cropper.showModal();
            }
        },
        cropUploadSuccess(imageUrl, field) {
            this.M.img = imageUrl;
        },
        openPromotionPage() {
            window.open('https://doctu.ru/' + this.city + (this.M.networkClinics?.length ? '/net/' : '/clinic/') + this.url + '/promo', '_blank');
        },
        hideAndRefresh () {
            this.$refs.dialog.hide();
            this.$parent.$refs.table.update();
        },
        formatDate: function (date) {
            let dateParts = date.split('.');
            return [dateParts[2], dateParts[1], dateParts[0]].join('-');
        },
        setDurationPreset: function () {
            this.M.duration = this.durationPreset;
            this.calculateDateTill();

            this.$nextTick(function () {
                this.durationPreset = '';
            });
        },
        calculateDateTill: function () {
            let startDate = this.M.dateFrom ? this.M.dateFrom : this.today;

            if (this.M.duration) {
                this.M.dateTill = this.$moment(startDate, "DD.MM.YYYY")
                    .add(this.M.duration - 1, 'days')
                    .format("DD.MM.YYYY");
            } else {
                this.M.dateTill = '';
            }
        },
        calculateDuration: function () {
            if (this.M.dateFrom && this.M.dateTill) {
                let a = this.$moment(this.M.dateTill, "DD.MM.YYYY");
                let b = this.$moment(this.M.dateFrom, "DD.MM.YYYY");

                this.M.duration = a.diff(b, 'days') + 1;
            } else {
                if (this.M.dateTill === '') {
                    this.M.duration = null;
                }
            }
        },
        handleClearDateTill: function (newDateTill) {
            if (!newDateTill) {
                this.M.duration = null;
            }
        },
    },
    watch: {
        'M.dateFrom' (val) {
            if (!val) {
                this.M.dateFrom = this.today;
            }
            if (this.M.duration) {
                this.calculateDateTill();
            }
        },
        'M.discount' (val){
            if (!val) {
                this.M.discount = null;
            }
        },
        needSave(val, oldVal) {
            if (val) {
                window.addEventListener("beforeunload", this.$root.beforeunloadEvent);
            } else {
                window.removeEventListener("beforeunload", this.$root.beforeunloadEvent);
            }

        },
    },
    computed:{
        ...mapState({
            currentUser: state => state.currentUser,
        }),
        showInvalidClinics () {
            return this.netInvalidShowFlag && this.M.networkClinics.filter((item) => item.checked === true).length === 0;
        },
        storagePublicUrl() {
            return STORAGE_PUBLIC;
        },
        startOfToday: function () {
            return this.$moment().startOf('day');
        },
        today: function () {
            return this.$moment().format("DD.MM.YYYY");
        },
        minDateTill: function () {
            let currentDate = this.$moment().startOf('day');
            let dateFrom = this.$moment(this.M.dateFrom, 'DD.MM.YYYY');

            return currentDate < this.$moment(this.M.dateFrom, 'DD.MM.YYYY') ? dateFrom : currentDate;
        },
        isActive: function () {
            const currentDate = this.$moment();
            const dateFrom = this.$moment(this.M.dateFrom, 'DD.MM.YYYY').startOf('day');
            const dateTo = this.$moment(this.M.dateTill, 'DD.MM.YYYY').endOf('day');

            return currentDate >= dateFrom && currentDate <= dateTo && this.M.approved;
        },
        quillConfig() {
            let container =  [{'list': 'bullet'}, 'clean', 'strike'];

            if (this.currentUser.role === 'admin') {
                container.push('textLowerCase');
            }

            return {
                customEvents: {
                    onTextChange: (quill, delta, oldDelta, source) => {

                        var listChanged = delta
                            .filter((op) => (op.attributes || {}).list === "bullet")
                            .length;

                        if (listChanged) {
                            var deltaBefore = quill.getContents();
                            var deltaNew = new Delta();
                            deltaBefore.eachLine((line, attr, i) => {
                                var d = line;
                                if (attr.list === 'bullet') {
                                    var dText = d
                                        .filter((op) => typeof op.insert === 'string')
                                        .map((op) => op.insert)
                                        .join('');

                                    var prefix = dText.match(/^([-*•·▪▫‣◦+—.)\s]|(\d{1,2}[\)\.]))+/ig) || [''];
                                    d = d.slice(prefix[0].length);
                                }

                                d.insert('\n', attr);
                                deltaNew = deltaNew.concat(d);
                            });
                            quill.updateContents(deltaBefore.diff(deltaNew), 'api');
                        }
                    }
                },
                modules: {
                    toolbar: {
                        container: container,
                    },
                },
                formats: ['list', 'indent', 'clean', 'strike'],
            };
        },
        needSave: function () {
            return (
                this.Mhashcode !== null &&
                (
                    (this.Mhashcode !== this.MhashNew) ||
                    (this.Mhashcode !== JSON.stringify(this.M).hashCode())
                )
            ) || this.actionType === 'create';
        },

    }
}
</script>
<style lang="scss">
#promotionEdit {
    max-width: 950px !important;

    & .mx-input {
        padding-bottom: 1px;
        color: black;
        font-size: 16px;
    }

    & .mx-icon-calendar, .mx-icon-clear {
        top: calc(50% - 2px);
    }

    & #cropper{
        max-height: 570px !important;
        width: 630px !important;
    }
    & .img-container {
        height: 380px;
        width: 510px !important;
        margin: 0 auto;
    }
    & .cropper-container.cropper-bg{
        margin: 0 auto;
        width: 500px !important;
    }
}
</style>
